import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { AuthProvider } from './context/AuthContext'

// 调试：检查root元素
const rootElement = document.getElementById('root')
console.log('Root element:', rootElement)

if (!rootElement) {
  console.error('Root element not found!')
} else {
  try {
    const root = createRoot(rootElement)
    console.log('Root created successfully')
    
    root.render(
      <StrictMode>
        <AuthProvider>
          <App />
        </AuthProvider>
      </StrictMode>,
    )
    console.log('Render called')
  } catch (error) {
    console.error('Error rendering:', error)
  }
}
